var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_5088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.375H14.75V16.875H17.25V14.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 2.5H26.75V0H24.25V2.5H7.75V0H5.25V2.5H3.75C1.68225 2.5 0 4.18225 0 6.25V28.25C0 30.3177 1.68225 32 3.75 32H12.0625H12.25H16.6101C15.7459 31.2866 14.9931 30.4431 14.3812 29.5H12.25H12.0625H3.75C3.06075 29.5 2.5 28.9393 2.5 28.25V11.75H29.5V14.25V14.375V14.3812C30.443 14.9931 31.2866 15.7459 32 16.6101V14.375V14.25V6.25C32 4.18225 30.3177 2.5 28.25 2.5ZM29.5 9.25H2.5V6.25C2.5 5.56075 3.06075 5 3.75 5H5.25V7.5H7.75V5H24.25V7.5H26.75V5H28.25C28.9393 5 29.5 5.56075 29.5 6.25V9.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 15.125C18.9101 15.125 15.125 18.9101 15.125 23.5625C15.125 28.2149 18.9101 32 23.5625 32C28.2149 32 32 28.2149 32 23.5625C32 18.9101 28.2149 15.125 23.5625 15.125ZM23.5625 29.5C20.2886 29.5 17.625 26.8364 17.625 23.5625C17.625 20.2886 20.2886 17.625 23.5625 17.625C26.8364 17.625 29.5 20.2886 29.5 23.5625C29.5 26.8364 26.8364 29.5 23.5625 29.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 19.375H22.25V24.8125H26.875V22.3125H24.75V19.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 19.375H9.75V21.875H12.25V19.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 19.375H4.75V21.875H7.25V19.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 14.375H4.75V16.875H7.25V14.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 24.375H4.75V26.875H7.25V24.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14.375H9.75V16.875H12.25V14.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 24.375H9.75V26.875H12.25V24.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_5088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f900a9932aea1c88665700a1d5d29934.svg";
export { ForwardRef as ReactComponent };